import { CoreOperationResult } from "../../core/index.js";
import { PimCreate } from "./pim-create.js";
import * as PIM from "../pim-vocabulary.js";
export class PimCreateAssociation extends PimCreate {
    static TYPE = PIM.CREATE_ASSOCIATION;
    pimAssociationEnds = [];
    pimIsOriented = false;
    constructor() {
        super();
        this.types.push(PimCreateAssociation.TYPE);
    }
    static is(resource) {
        return resource?.types.includes(PimCreateAssociation.TYPE);
    }
}
export class PimCreateAssociationResult extends CoreOperationResult {
    static TYPE = PIM.CREATE_ASSOCIATION_RESULT;
    createdPimAssociation;
    createdPimAssociationEnds;
    constructor(createdPimAssociation, createdPimAssociationEnds) {
        super();
        this.types.push(PimCreateAssociationResult.TYPE);
        this.createdPimAssociation = createdPimAssociation;
        this.createdPimAssociationEnds = createdPimAssociationEnds;
    }
    static is(resource) {
        return resource?.types.includes(PimCreateAssociationResult.TYPE);
    }
}
//# sourceMappingURL=pim-create-association.js.map